import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Dialog from '@radix-ui/react-dialog';
import './Modal.css';

import IconClose from '../svg/IconClose'

import { connect } from "react-redux";
import { setModal } from "../../../actions/index";
import { setStateShortcuts } from "../shortcut/redux/actions/index";

const srOnly = {
  position: 'absolute', width: 1, height: 1, padding: 0, margin: -1,
  overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap', border: 0
};

function ConnectedModal({
  title = null, description = null, content = null, active = false, enableHeader = false, underlayClickExits = true, height, style,
  underlayBackground = `rgba(57,57,57,0.8)`,
  setModal, setStateShortcuts
}) {
  const [modalHasEntered, setModalHasEntered] = useState(false);

  const deactivateModal = () => {
    setModalHasEntered(false);
    setTimeout(() => {
      setModal({ title: null, description: null, content: null, active: false });
      setStateShortcuts(true);
    }, 300);
  };

  // Réplique l'ancien onEnter de AriaModal : déclenche l'animation d'entrée une fois monté.
  useEffect(() => {
    if (active) {
      const id = requestAnimationFrame(() => setModalHasEntered(true));
      return () => cancelAnimationFrame(id);
    }
    setModalHasEntered(false);
  }, [active]);

  // cleanup Radix
  useEffect(() => {
    if (active) return;
    const id = requestAnimationFrame(() => {
      if (document.body.style.pointerEvents === 'none') {
        document.body.style.pointerEvents = '';
      }
    });
    return () => cancelAnimationFrame(id);
  }, [active]);

  return (
    <Dialog.Root open={active} onOpenChange={(open) => { if (!open) deactivateModal(); }}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={`underlay ${modalHasEntered && `has-entered`} ${Config.API_NAME} `}
          style={{
            width: `100%`, height: document.body.clientHeight,
            position: `relative`,
            background: underlayBackground,
            display: `flex`, alignItems: `center`, justifyContent: `center`
          }}
        >
          <Dialog.Content
            aria-describedby={undefined}
            onOpenAutoFocus={(e) => e.preventDefault()}
            onEscapeKeyDown={(e) => { if (!underlayClickExits) e.preventDefault(); }}
            onPointerDownOutside={(e) => { if (!underlayClickExits) e.preventDefault(); }}
            onInteractOutside={(e) => { if (!underlayClickExits) e.preventDefault(); }}
            asChild
          >
            <div tabIndex={0} className={`modal bpc flexColumn modal--animated ${modalHasEntered && `has-entered`}`} style={{ textAlign: `center`, ...style }}>
              <Dialog.Title style={srOnly}>ModalBP</Dialog.Title>
              { enableHeader ? (
                <>
                  { underlayClickExits && <IconClose size={16} onClick={deactivateModal} className={`modal-close-icon`} /> }
                  <header className="flexColumn modal-header">
                    <span className={`type-title type-light`}>{title}</span>
                    <span className={`type-small type-secondary ${description !== null && `description`}`}>{description}</span>
                  </header>
                </>
              ) : (
                <header id={`modal-h`} className="flexColumn modal-top">
                  <span className={`type-title type-light`}>{title}</span>
                  <span className={`type-small type-secondary description`}>{description}</span>
                </header>
              )}
              <div className="modal-body">
                <div className={`flexColumn modal-form-container`} style={{ ...style }}>
                  { content && React.cloneElement(content, { cancelClick: (content.props.cancelClick) ? content.props.cancelClick : deactivateModal, modalHasEntered }) }
                </div>
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

ConnectedModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  content: PropTypes.any,
  active: PropTypes.bool,
  enableHeader: PropTypes.bool,
  height: PropTypes.number.isRequired,
  style: PropTypes.object
}

const ModalV2 = connect(
  null,
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    setStateShortcuts: state => dispatch(setStateShortcuts(state))
  })
)(ConnectedModal);

export default ModalV2;
